var render = function render(){var _vm=this,_c=_vm._self._c;return _c('board-filtered-search',{attrs:{"data-testid":"issue-board-filtered-search","tokens":_vm.tokens,"board":_vm.board,"is-swimlanes-on":_vm.isSwimlanesOn,"filters":_vm.filters},on:{"set-filters":function($event){return _vm.$emit('set-filters', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }